import * as React from 'react'
import { AccoladeMeetYourCoach } from './Accolade'
import { useTranslation } from '../../../hooks/useTranslation'

const AccoladeCards = ({
  yearsExperience,
  numClientsSupported,
  satisfactionRating,
  className,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <AccoladeMeetYourCoach
        rating={`${yearsExperience}+`}
        title={t('accolades.yearsExperience.title')}
        className={className}
      />
      <AccoladeMeetYourCoach
        rating={`${numClientsSupported}+`}
        title={t('accolades.clientsSupported.title')}
        className={className}
      />
      <AccoladeMeetYourCoach
        rating={`${satisfactionRating}%`}
        title={t('accolades.satisfactionRating.title')}
        className={className}
      />
    </>
  )
}
export default AccoladeCards

export const LiaisonAccoladeCards = ({ className }) => {
  const { t } = useTranslation('accolades')
  return (
    <>
      <AccoladeMeetYourCoach
        rating="10,000+"
        title={t('matchesMade.title')}
        className={className}
      />
      <AccoladeMeetYourCoach
        rating="16+"
        title={t('yearsExperience.title')}
        className={className}
      />
      <AccoladeMeetYourCoach
        rating="97%"
        title={t('satisfactionRating.title')}
        className={className}
      />
    </>
  )
}
